define(["require", "exports", "tslib", "lodash.throttle"], function (require, exports, tslib_1, lodash_throttle_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.metrics = void 0;
    lodash_throttle_1 = (0, tslib_1.__importDefault)(lodash_throttle_1);
    var METRICS_ENDPOINT = "https://api.amplitude.com/2/httpapi";
    var cache = [];
    var isTrackingDisabled = false;
    var uploadMetrics = (0, lodash_throttle_1.default)(function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
        var toUpload, e_1;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    toUpload = cache;
                    cache = [];
                    if (!window._env_.AMPLITUDE_API_KEY || isTrackingDisabled) {
                        console.log("Not uploading metrics", toUpload);
                        return [2];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, fetch(METRICS_ENDPOINT, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                api_key: window._env_.AMPLITUDE_API_KEY,
                                events: toUpload,
                            }),
                        })];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    e_1 = _a.sent();
                    isTrackingDisabled = true;
                    console.error(e_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); }, 500);
    var getUserId = function () {
        var storedId = localStorage.getItem("metrics_user_id");
        if (!storedId) {
            var newId = Math.random().toString().split(".")[1];
            localStorage.setItem("metrics_user_id", newId);
            return newId;
        }
        return storedId;
    };
    var emitMetric = function (name, body) {
        cache.push({
            event_type: name,
            event_properties: body,
            user_id: getUserId(),
            device_id: window.navigator.userAgent,
        });
        uploadMetrics();
    };
    exports.metrics = {
        emitMetric: emitMetric,
    };
});
//# sourceMappingURL=index.js.map